import "./styles/main.scss";

import { RouterProvider } from "react-router-dom";
import { AppProviders } from "./context/Providers";
import { router } from "./routes/router";

const App = () => {
  return (
    <AppProviders>
      <RouterProvider router={router} />
    </AppProviders>
  );
};

export default App;
